import ReactTagInput from "@pathofdev/react-tag-input";
import {
  Button,
  Input,
  TableCell,
  TableContainer,
  TableHeader,
  Textarea,
  Table,
} from "@windmill/react-ui";
import Multiselect from "multiselect-react-dropdown";
import React from "react";
import { useEffect, useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";

import { useForm } from "react-hook-form";
import { notifySuccess,notifyError } from "utils/toast";
import { Scrollbars } from "react-custom-scrollbars-2";
import { MultiSelect } from "react-multi-select-component";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiX } from "react-icons/fi";
import UploaderThree from "components/image-uploader/UploaderThree";
import Title from "components/form/Title";
import SwitchToggleForCombination from "components/form/SwitchToggleForCombination";
import ActiveButton from "components/form/ActiveButton";
import LabelArea from "components/form/LabelArea";
import Error from "components/form/Error";
import Uploader from "components/image-uploader/Uploader";
import InputArea from "components/form/InputArea";
import ParentCategory from "components/category/ParentCategory";
import InputValue from "components/form/InputValue";
import InputValueFive from "components/form/InputValueFive";
import AttributeOptionTwo from "components/attribute/AttributeOptionTwo";
import DrawerButton from "components/form/DrawerButton";
import AttributeListTable from "components/attribute/AttributeListTable";
import { showingTranslateValue } from "utils/translate";
import ServiceServices from "services/ServiceServices";
import SidebarContent from "components/sidebar/SidebarContent";
import ReferencesServices from "services/ReferencesServices";
import DepartmentServices from "services/DepartementServices";
import useDepartmentSubmit from "hooks/useDepartmentSubmit";
import useFileField from "hooks/useFileField";
import FileInputWithRemove from "components/form/FileInputWithRemove";
//internal import

const DepartmentDrawer = ({ id, data, isLoading, setIsLoading, isCheck, setIsCheck }) => {
  const { t } = useTranslation();


  const {
    tag,
    setTag,
    values,
    language,
    register,
    onSubmit,
    errors,
    slug,
    tapValue,
    setTapValue,
    openModal,
    attribue,
    setValues,
    variants,
    isCombination,
    variantTitle,
    attributes,
    attTitle,
    handleAddAtt,
    // productId,
    onCloseModal,
    isBulkUpdate,
    globalSetting,
    isSubmitting,
    resetRefTwo,
    handleSkuBarcode,
    handleServiceTap,
    selectedCategory,
    setSelectedCategory,
    setDefaultCategory,
    defaultCategory,
    handleProductSlug,
    handleSelectLanguage,
    handleIsCombination,
    handleEditVariant,
    handleRemoveVariant,
    handleClearVariant,
    handleQuantityPrice,
    handleSelectImage,
    handleSelectInlineImage,
    handleGenerateCombination,
  } = useDepartmentSubmit(id, data);

  const currency = globalSetting?.default_currency || "$";
  // closeDrawer();
  const { closeDrawer } = useContext(SidebarContext)

  const imageField = useFileField();
  const [title_en, setTitle_en] = useState("");
  const [title_fr, setTitle_fr] = useState("");
  const [title_ar, setTitle_ar] = useState("");
  const [description_en, setDescription_en] = useState("");
  const [description_fr, setDescription_fr] = useState("");
  const [description_ar, setDescription_ar] = useState("");
  const {
    setValue,

  } = useForm();
  const [retsData, setRestData] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const Error = ({ errorName }) => {
      return (
        <div className="text-red-500 text-sm mt-1">{errorName && errorName.message}</div>
      );
    };

    const formData = new FormData();
    formData.append('title_en', title_en);
    formData.append('title_fr', title_fr);
    formData.append('title_ar', title_ar);
    imageField.appendToFormData(formData, 'image', 'remove_image');
    formData.append('description_en', description_en);
    formData.append('description_fr', description_fr);
    formData.append('description_ar', description_ar);

    if (id) {
      if (!title_en || !title_fr|| !title_ar|| !description_en || !description_fr || !description_ar){
        notifyError("Remplir tous les champs!");
      } else {
      try {
        setIsLoading(true);
        const res = await DepartmentServices.updateDepartment(id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        // setIsUpdate(true);
        closeDrawer();

        notifySuccess(res.message);
        setIsLoading(false);
        setIsCheck([]);
        // setIsSubmitting(false);



        setTitle_en("");
        setTitle_fr("");
        setTitle_ar("");
        setDescription_en("");
        setDescription_fr("");
        setDescription_ar("");
        imageField.reset();

        setIsCheck([]);
        // reset();
      } catch (error) {
        const errorMessage = "Erreur lors de modification d'un département : " + error;
        notifyError(errorMessage);

      }
    }
    } else {
      if (!title_en || !title_fr|| !title_ar|| !imageField.hasValue|| !description_en || !description_fr || !description_ar){
        notifyError("Remplir tous les champs!");
      } else {
      try {
        setIsLoading(true);

        const res = await DepartmentServices.addDepartment(formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        // setIsUpdate(true);
        // setIsSubmitting(false);
        closeDrawer();
        notifySuccess(res.message);

        setIsLoading(false);
        setIsCheck([]);



        setTitle_en("");
        setTitle_fr("");
        setTitle_ar("");
        setDescription_en("");
        setDescription_fr("");
        setDescription_ar("");
        imageField.reset();
        setIsCheck([]);
      
      } catch (error) {

        const errorMessage = "Erreur lors d'ajout d'un département : " + error;
        notifyError(errorMessage);
      }
    }
    }
  };
  const initFormForUpdate = async (id) => {

    setIsLoading(true);
    const res = await DepartmentServices.getDepartmentById(id);
    setIsLoading(false);


    setTitle_en(res.data.title_en);
    setTitle_fr(res.data.title_fr);
    setTitle_ar(res.data.title_ar);
    setDescription_en(res.data.description_en);
    setDescription_fr(res.data.description_fr);
    setDescription_ar(res.data.description_ar);
    imageField.loadExisting(res.data.image);
  };


  useEffect(() => {
    if (id && id !== undefined) {
      initFormForUpdate(id);
    } else {
      setTitle_en("");
      setTitle_fr("");
      setTitle_ar("");
      setDescription_en("");
      setDescription_fr("");
      setDescription_ar("");
      imageField.reset();

    }
  }, [id]);
  const handleSubmitClick = () => {
    // Place your submission logic here
  };


  const handleNextClick = () => {
    if (tapValue === 'Anglais') {
      setTapValue('French');
    } else if (tapValue === 'French') {
      setTapValue('Arabic');
    }
  };


  const [imageBinary, setImageBinary] = useState(null);
  const imageFetchUrl = imageField.getFetchUrl();
  useEffect(() => {
    async function fetchImageBinary() {
      if (!imageFetchUrl) {
        setImageBinary(null);
        return;
      }
      try {
        const response = await fetch(imageFetchUrl);
        const blob = await response.blob();
        setImageBinary(blob);
      } catch (error) {
        console.error('Error fetching image binary:', error);
      }
    }

    fetchImageBinary();
  }, [imageFetchUrl]);

  return (
    <>
      <Modal
        open={openModal}
        onClose={onCloseModal}
        center
        closeIcon={
          <div className="absolute top-0 right-0 text-red-500 focus:outline-none active:outline-none text-xl border-0">
            <FiX className="text-3xl" />
          </div>
        }
      >
        <div className="cursor-pointer">
          <UploaderThree
            imageUrl={imageField.previewSrc}
            setImageUrl={imageField.loadExisting}
            handleSelectImage={handleSelectImage}
          />
        </div>
      </Modal>

      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title
            register={register}
            // handleSelectLanguage={handleSelectLanguage}
            title={"Update Department"}
            description={"Update Department Description"}
          />
        ) : (
          <Title
            register={register}
            // handleSelectLanguage={handleSelectLanguage}
            title={"Add Department"}
            description={"Add Department Description"}
          />
        )}
      </div>


      <Scrollbars className="track-horizontal thumb-horizontal w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit} className="block" id="block">

          <div className="px-6 pt-8 flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Image"} />
              <div className="col-span-8 sm:col-span-4">
                <FileInputWithRemove field={imageField} name="imageUrl" accept="image/*" placeholder="Image" />
                <Error errorName={errors.imageUrl} />
              </div>
            </div>



            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Title (en) "} />
              <div className="col-span-8 sm:col-span-4">
                <Input

                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="title_en"
                  type="text"
                  placeholder={"Department Title (en) "}
                  // onBlur={(e) => handleProductSlug(e.target.value)}
                  onChange={(e) => setTitle_en(e.target.value)}
                  value={title_en}
                  required={true}

                />

                <Error errorName={errors.title_en} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Title (fr) "} />
              <div className="col-span-8 sm:col-span-4">
                <Input

                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="title_fr"
                  type="text"
                  placeholder={"Department Title (fr) "}
                  // onBlur={(e) => handleProductSlug(e.target.value)}
                  onChange={(e) => setTitle_fr(e.target.value)}
                  value={title_fr}
                  required={true}

                />

                <Error errorName={errors.title_fr} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Title (ar) "} />
              <div className="col-span-8 sm:col-span-4">
                <Input

                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="title_ar"
                  type="text"
                  placeholder={"Department Title (ar) "}
                  // onBlur={(e) => handleProductSlug(e.target.value)}
                  onChange={(e) => setTitle_ar(e.target.value)}
                  value={title_ar}
                  required={true}

                />
                <Error errorName={errors.title_ar} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Description (en) "} />
              <div className="col-span-8 sm:col-span-4">
                <Textarea
                  className="border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"

                  name="description_en"
                  placeholder={"Department Description (en) "}
                  rows="4"
                  spellCheck="false"
                  onChange={(e) => setDescription_en(e.target.value)}
                  value={description_en}
                  required={true}

                />

                <Error errorName={errors.description_en} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Description (fr) "} />
              <div className="col-span-8 sm:col-span-4">
                <Textarea
                  className="border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"

                  name="description_fr"
                  placeholder={"Department Description (fr) "}
                  rows="4"
                  spellCheck="false"
                  onChange={(e) => setDescription_fr(e.target.value)}
                  value={description_fr}
                  required={true}

                />
                <Error errorName={errors.description_fr} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={"Department Description (ar) "} />
              <div className="col-span-8 sm:col-span-4">
                <Textarea
                  className="border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"

                  name="description_ar"
                  placeholder={"Department Description (ar) "}
                  rows="4"
                  spellCheck="false"
                  onChange={(e) => setDescription_ar(e.target.value)}
                  value={description_ar}
                  required={true}

                />
                <Error errorName={errors.description_ar} />
              </div>
            </div>
          </div>
          <DrawerButton id={id} title="Submit" isSubmitting={isSubmitting} />


          {
            id ? (
              <>

                <DrawerButton id={id} title="Submit" value="submit" isSubmitting={isSubmitting} onClick={handleSubmitClick} />

              </>
            ) : (
              <>
                <DrawerButton id={id} title="Submit" value="submit" isSubmitting={isSubmitting} onClick={handleSubmitClick} />

              </>
            )
          }
        </form>


      </Scrollbars>




    </>
  );
};

export default React.memo(DepartmentDrawer);
